import apiRequest from "../../helpers/apiRequest";

export default async (formData) => {
    return await apiRequest({
        method: 'post',
        url: `content/create/note/`,
        data: formData
    })
}
